import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import cn from 'classnames';
import { border, transition } from '@topconagriculture/theme';
const styles = (theme) => createStyles({
    tooltipWrapper: {
        position: 'relative',
        '&:hover $tooltip': {
            visibility: 'visible',
            opacity: 1,
        },
    },
    tooltip: {
        transition: transition(200),
        opacity: 0,
        visibility: 'hidden',
        position: 'absolute',
        bottom: '200%',
        left: '50%',
        transform: 'translateX(-50%)',
        padding: 10,
        borderRadius: theme.common.borderRadius.default,
        backgroundColor: theme.color.grey.lightest,
        lineHeight: theme.font.lineHeight.mediumBig,
        boxShadow: theme.common.shadow.default,
        textAlign: 'center',
        fontSize: theme.font.size.medium,
    },
    tooltipArrow: {
        opacity: 1,
        position: 'absolute',
        height: 0,
        width: 0,
        borderWidth: '7px',
        bottom: -14,
        left: 'calc(50% - 7px)',
        borderColor: 'transparent',
        borderTopColor: theme.color.grey.lightest,
        borderStyle: 'solid',
    },
    activatorWrapper: {
        paddingBottom: 1,
        '&:hover': {
            borderBottom: border(theme.color.grey.darkest, 2),
        },
    },
});
const TooltipBox = (props) => {
    const { classes, className: classNameProp, children, activatorComponent, underlineOnHover, testId = 'TooltipBox', } = props;
    return (React.createElement("div", { className: cn(classes.tooltipWrapper, classNameProp), "data-testid": `${testId}` },
        React.createElement("span", { className: underlineOnHover ? classes.activatorWrapper : '' }, activatorComponent),
        React.createElement("div", { className: classes.tooltip },
            React.createElement("div", { className: classes.tooltipArrow }),
            children)));
};
const ComposedTooltipBox = compose(withStyles(styles, { withTheme: true }), pure)(TooltipBox);
ComposedTooltipBox.displayName = 'TooltipBox';
export default ComposedTooltipBox;
//# sourceMappingURL=TooltipBox.js.map